import nyNetwork from "@/api/nyBaseNetwork";
import DZSearchLand from "@/views/审核管理/model/search/DZSearchLand";
import DZModelListLand from "@/views/审核管理/model/list/DZModelListLand";
import DZModelAddress from "@/views/审核管理/model/DZModelAddress";
import DZModelContacts from "@/views/审核管理/model/DZModelContacts";
import DZModelWarrant from "@/views/审核管理/model/DZModelWarrant";
import DZModelTraffic from "@/views/审核管理/model/DZModelTraffic";
import DZModelOther from "@/views/审核管理/model/DZModelOther";
import DZModelLandBase from "@/views/审核管理/model/DZModelLandBase";

class DZServiceLand{

    m_search = new DZSearchLand(10);
    /** 土地审核列表 **/
    list_land : Array<DZModelListLand> = [];

    sum = {
        all:'',
        listed:'',
        delisted:'',
        unaudited:''
    }

    /** 土地基本信息 **/
    base = new DZModelLandBase();
    /** 位置 **/
    address = new DZModelAddress();
    /** 联系人 **/
    contact = new DZModelContacts();
    /** 权证 **/
    warrant = new DZModelWarrant();
    /** 交通 **/
    traffic = new DZModelTraffic();
    /** 其他 **/
    other = new DZModelOther();

    net_page_land(){
        nyNetwork.net("土地信息审核列表",this.m_search, data => {
            this.list_land = data.list
            this.m_search.total = data.total
        })
        nyNetwork.net("土地信息审核列表统计",this.m_search, res => {
            if(res){
                this.sum.all = res.all
                this.sum.listed = res.listed
                this.sum.delisted = res.delisted
                this.sum.unaudited = res.unaudited
            }
        })
    }

    net_land_info(id){
        nyNetwork.net("土地信息详情",{id:id}, data => {
            this.base = data.baseInfo
            this.address = data.addressInfo
            this.contact = data.contactsInfo
            this.warrant = data.warrantInfo
            this.traffic = data.trafficInfo
            this.other = data.otherInfo
        })
    }

    net_edit_land_base(m){
        nyNetwork.net("修改土地基本信息",m, data => {

        })
    }

    net_edit_address(m){
        nyNetwork.net("修改土地位置",m, data => {

        })
    }

    net_edit_contact(m){
        nyNetwork.net("修改土地联系人",m, data => {

        })
    }

    net_edit_warrant(m){
        nyNetwork.net("修改土地权证",m, data => {

        })
    }

    net_edit_traffic(m){
        nyNetwork.net("修改土地交通",m, data => {

        })
    }

    net_edit_other(m){
        nyNetwork.net("修改土地其他", m, data => {

        })
    }

    net_land_pass(id,success: () => void){
        nyNetwork.net("土地审核通过",{id:id}, data => {
            success()
        })
    }

    net_land_refuse(id,success: () => void){
        nyNetwork.net("土地审核拒绝",{id:id}, data => {
            success()
        })
    }

    net_land_operate(id,success: () => void){
        nyNetwork.net("土地暂停/继续发布",{id:id}, data => {
            success()
        })
    }

    net_batch_deList(idList,success: () => void){
        nyNetwork.net("土地批量下架",[...idList], data => {
            success()
        })
    }

}
export default DZServiceLand;
